import React from 'react';
import styled from '@emotion/styled';

import { FileDownload } from '../../types/types';

const Ul = styled.ul({
  flexDirection: 'row !important' as any,
  // override style based on designs
});

type Props = {
  files: FileDownload[];
};

export const DocumentsFilesList: React.FC<Props> = props => {
  const { files } = props;

  return (
    <Ul className='downloads' data-testid='mp-product-documents-files'>
      {files?.map((file, i) => (
        <li key={i}>
          <a href={file.url}>{file.name}</a>
          <small>({file.type})</small>
        </li>
      ))}
    </Ul>
  );
};
